import {ApiV0} from '../api.v0';
import {RestApiService} from '../../rest-api.service';
import {ApiV0FibuBooking} from './fibu/api.v0.fibu.booking';
import {ApiV0FibuMisc} from './fibu/api.v0.fibu.misc';
import {ApiV0FibuBanking} from './fibu/api.v0.fibu.banking';
import {ApiV0FibuAccounts} from './fibu/api.v0.fibu.accounts';
import {CookieType} from '../../../models/cp-auth-types';
import {CookieService} from 'ngx-cookie-service';

export class ApiV0Fibu {

    segment: string;

    constructor(
        v0: ApiV0,
        api: RestApiService,
        private cookieService: CookieService,
    ) {
        this.segment = v0.segment + '/fibu';
        this.booking = new ApiV0FibuBooking(this, api);
        this.accounts = new ApiV0FibuAccounts(this, api);
        this.banking = new ApiV0FibuBanking(this, api)
        this.misc = new ApiV0FibuMisc(this, api)
    }


    public readonly booking: ApiV0FibuBooking;
    public readonly accounts: ApiV0FibuAccounts;
    public readonly banking: ApiV0FibuBanking;
    public readonly misc: ApiV0FibuMisc;

    bookingMonthChanged($event: any) {
        this.cookieService.set(CookieType.FinancialMonth, $event, {path: "/"});
    }

    bookingMonth(): number {
        let cookieMonth = this.cookieService.get(CookieType.FinancialMonth);
        let month = Number(cookieMonth);
        if (cookieMonth === "") {
            month = new Date().getMonth() + 1;
            this.bookingMonthChanged(month);
        }
        return month;
    };

    bookingYear(): number {
        let cookieYear = this.cookieService.get(CookieType.FinancialYear);
        let year = Number(cookieYear);
        if (cookieYear === "") {
            year = new Date().getFullYear();
            this.bookingYearChanged(year);
        }
        return year;
    };

    bookingYearChanged($event: any) {
        this.cookieService.set(CookieType.FinancialYear, $event, {path: "/"});
    }
}
